var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-view"},[_c('div',{staticClass:"scrollable-content",style:({ transform: 'translateX(' + _vm.scrollPosition + 'px)' })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }